export function combineBOMs(boms) {
  const names = [...new Set(boms.flatMap(bom => bom.columns.map(column => column.name)))];
  const rows = boms.flatMap(bom => bom.items.map(item => ({
    id: JSON.stringify([bom.bom_id, item.line_item_id]),
    bom_id: bom.bom_id, line_item_id: item.line_item_id, order_index: item.order_index,
    source_bom: bom.name, bom, item,
    data: Object.fromEntries(bom.columns.map(column => [column.name, item.data[column.id] ?? '']))
  })));
  return { names, rows };
}

export function searchCombined(rows, search) {
  const query = search.trim().toLowerCase();
  return rows.filter(row => [row.source_bom, ...Object.values(row.data)]
    .some(value => String(value).toLowerCase().includes(query)));
}
